class GamaTalleres {
  constructor(section) {
    this.section = section;
    this.container = section.querySelector('.gama-talleres__container');
    this.slides = Array.from(section.querySelectorAll('.gama-talleres__slide'));
    this.prev = section.querySelector('[data-gama-prev]');
    this.next = section.querySelector('[data-gama-next]');
    this.dotsContainer = section.querySelector('[data-gama-dots]');
    this.index = 0;

    this.initDots();
    this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
    this.next?.addEventListener('click', () => this.goTo(this.index + 1));

    window.addEventListener('resize', () => this.goTo(this.index));
  }

  initDots() {
    if (!this.dotsContainer || !this.slides.length) return;
    this.dotsContainer.innerHTML = '';
    this.slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `gama-talleres__dot${i === 0 ? ' is-active' : ''}`;
      dot.ariaLabel = `Ir al taller ${i + 1}`;
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsContainer.appendChild(dot);
    });
  }

  goTo(index) {
    if (!this.slides.length) return;

    this.index = Math.max(0, Math.min(index, this.slides.length - 1));
    const slideWidth = this.slides[0].getBoundingClientRect().width;

    this.container.style.transform = `translateX(-${slideWidth * this.index}px)`;
    this.container.style.transition = 'transform .35s ease';

    // Update active dot
    const dots = Array.from(this.dotsContainer?.querySelectorAll('.gama-talleres__dot') || []);
    dots.forEach((dot, i) => {
      if (i === this.index) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gama-talleres]').forEach(section => {
    new GamaTalleres(section);
  });
});